import { formatApiError, getFieldErrors } from "./laravelError";

export function indexPlacesByUuid(places) {
  const map = new Map();
  for (const place of places || []) {
    if (place?.uuid) map.set(place.uuid, place);
  }
  return map;
}

/** Cruza accommodation_id con la lista/caché de lugares para nombre y localidad. */
export function enrichMeetingWithPlace(meeting, placesByUuid) {
  if (!meeting || !placesByUuid?.size) return meeting;
  const accommodationId = meeting.accommodationId ?? meeting.placeUuid;
  if (!accommodationId) return meeting;

  const place = placesByUuid.get(accommodationId);
  if (!place) {
    return { ...meeting, accommodationId, placeUuid: accommodationId };
  }

  return {
    ...meeting,
    accommodationId,
    placeUuid: accommodationId,
    placeName: place.name ?? meeting.placeName,
    placeLocality: place.addressLocality ?? meeting.placeLocality,
  };
}

export function enrichMeetingsWithPlaces(meetings, places) {
  const byUuid = indexPlacesByUuid(places);
  return (meetings || []).map((m) => enrichMeetingWithPlace(m, byUuid));
}

const ACCOMMODATION_FIELD_MESSAGES = {
  required: "Debes seleccionar un hospedaje para publicar el encuentro.",
  invalid: "El hospedaje seleccionado no es válido. Elige otro hotel de la lista.",
};

export function formatMeetingCreateError(err, fallback = "No se pudo crear el encuentro") {
  if (err?.response?.status === 422) {
    const fields = getFieldErrors(err);
    if (fields.accommodation_id) {
      return String(fields.accommodation_id);
    }
  }

  return formatApiError(err, fallback);
}

export function resolveAccommodationId(payload) {
  return payload?.accommodationId ?? payload?.placeUuid ?? null;
}

export function assertAccommodationSelected(payload) {
  const id = resolveAccommodationId(payload);
  if (!id) {
    throw new Error(ACCOMMODATION_FIELD_MESSAGES.required);
  }
  return id;
}

export { ACCOMMODATION_FIELD_MESSAGES };
